function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["children", "childrenWrapperProps", "className", "count", "countProps", "disabled", "endIcon", "endIconProps", "fullWidth", "loaderProps", "loading", "look", "size", "startIcon", "startIconProps"],
  _excluded2 = ["fullWidth", "look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useState, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonVariants, ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import { LoaderSizes } from "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import { baseButtonStyle, getButtonTheme, getButtonWidth } from "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import { getLoaderLookFromButtonLook } from "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { FontIcon } from "../../icon/font-icon/font-icon.js";
import { CircleLoader } from "../../loader/circle-loader/circle-loader.js";
import "../../loader/shimmer-loader/shimmer-loader.js";
import { BaseButton } from "../base-button/base-button.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var children = props.children,
    childrenWrapperProps = props.childrenWrapperProps,
    className = props.className,
    count = props.count,
    countProps = props.countProps,
    disabled = props.disabled,
    endIcon = props.endIcon,
    endIconProps = props.endIconProps,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    loaderProps = props.loaderProps,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    look = props.look,
    size = props.size,
    startIcon = props.startIcon,
    startIconProps = props.startIconProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(getLoaderLookFromButtonLook(look)),
    _useState2 = _slicedToArray(_useState, 2),
    loaderLook = _useState2[0],
    setLoaderLook = _useState2[1];
  useEffect(function () {
    setLoaderLook(getLoaderLookFromButtonLook(look));
  }, [loading, look]); // eslint-disable-line react-hooks/exhaustive-deps
  return /*#__PURE__*/React.createElement(BaseButton, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-button__standard--disabled': disabled,
      'bf-button__standard--full-width': fullWidth
    }, _defineProperty(_classnames, "bf-button__standard--".concat(look), look), _defineProperty(_classnames, "bf-button__standard--".concat(size), !!size), _defineProperty(_classnames, "".concat(className), className), _classnames)),
    disabled: disabled,
    loading: loading,
    ref: ref,
    variant: ButtonVariants.Standard
  }), loading && /*#__PURE__*/React.createElement(CircleLoader, _extends({
    buttonLook: look,
    label: "",
    look: loaderLook,
    size: LoaderSizes.Small
  }, loaderProps, {
    className: classnames(_defineProperty({
      'bf-button__standard__loader': true
    }, "".concat(loaderProps === null || loaderProps === void 0 ? void 0 : loaderProps.className), !!(loaderProps !== null && loaderProps !== void 0 && loaderProps.className)))
  })), startIcon && /*#__PURE__*/React.createElement(FontIcon, _extends({}, startIconProps, {
    className: classnames(_defineProperty({
      'bf-button__standard__start-icon': true
    }, "".concat(startIconProps === null || startIconProps === void 0 ? void 0 : startIconProps.className), !!(startIconProps !== null && startIconProps !== void 0 && startIconProps.className))),
    icon: startIcon
  })), /*#__PURE__*/React.createElement("span", _extends({}, childrenWrapperProps, {
    className: classnames(_defineProperty({
      'bf-button__standard__children': true
    }, "".concat(childrenWrapperProps === null || childrenWrapperProps === void 0 ? void 0 : childrenWrapperProps.className), !!(childrenWrapperProps !== null && childrenWrapperProps !== void 0 && childrenWrapperProps.className)))
  }), children), endIcon && /*#__PURE__*/React.createElement(FontIcon, _extends({}, endIconProps, {
    className: classnames(_defineProperty({
      'bf-button__standard__end-icon': true
    }, "".concat(endIconProps === null || endIconProps === void 0 ? void 0 : endIconProps.className), !!(endIconProps !== null && endIconProps !== void 0 && endIconProps.className))),
    icon: endIcon
  })), count !== undefined && /*#__PURE__*/React.createElement("span", _extends({}, countProps, {
    className: classnames(_defineProperty({
      'bf-button__standard__count': true
    }, "".concat(countProps === null || countProps === void 0 ? void 0 : countProps.className), !!(countProps !== null && countProps !== void 0 && countProps.className)))
  }), count));
});
var Button = styled(BaseStandardButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n\n  .bf-icon {\n    font-size: 14px;\n  }\n\n  .bf-button__standard__end-icon {\n    margin-inline-start: 10px;\n  }\n\n  .bf-button__standard__start-icon {\n    margin-inline-end: 10px;\n  }\n\n  .bf-button__standard__count {\n    margin-inline-start: 10px;\n  }\n\n  .bf-button__standard__loader {\n    margin-inline-end: 10px;\n  }\n\n  .bf-loader__circle {\n    width: auto;\n  }\n"])), baseButtonStyle, function (_ref) {
  var look = _ref.look;
  return getButtonTheme({
    look: look
  });
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth,
    size = _ref2.size;
  return getButtonWidth({
    fullWidth: fullWidth,
    size: size
  });
});
var StandardButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$fullWidth2 = props.fullWidth,
    fullWidth = _props$fullWidth2 === void 0 ? false : _props$fullWidth2,
    _props$look = props.look,
    look = _props$look === void 0 ? ButtonLooks.Primary : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    fullWidth: fullWidth,
    look: look,
    ref: ref
  })));
});
export { BaseStandardButton, StandardButton };